import { render, staticRenderFns } from "./OnlineWellbeingAssessment.vue?vue&type=template&id=39ea2ec0&"
import script from "./OnlineWellbeingAssessment.vue?vue&type=script&lang=js&"
export * from "./OnlineWellbeingAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports